export const enum ShortNameSort {
  ASC = 'asc',
  DESC = 'desc',
}

export const enum FullNameSort {
  ASCEND = 'ascend',
  DESCEND = 'descend',
}
